import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { BasicDialogComponent, BasicDialogComponentProps } from "./BasicDialogComponent";

export type BasicDialogProps = {
    readonly cancelTextLocKey: string;
};

type StateProps = Pick<BasicDialogComponentProps, "cancelText">;

const mapStateToProps: MapStateToProps<StateProps, BasicDialogProps, IAppState> = (state, { cancelTextLocKey }) => ({
    cancelText: getPrimaryText(state, cancelTextLocKey) ?? "",
});

export const BasicDialog = connect(mapStateToProps)(BasicDialogComponent);
